import { IMenuItem } from 'src/components/GlobalHeader/types';
import { IUserColumns } from 'src/Entities/User/User';

const DB_ENV: string = process.env.REACT_APP_DB_ENV || 'production';
// here we define the apps rpoutes.

// should help create the menu items. for the menu so that its based on the users
// Roles, this
export class RouteHelper {
  private static routeHelper: RouteHelper;

  public Themeids: string[] =['1400074', '1400072', '1400073'];

  public items: IMenuItem[] = [
    {
      label: '3F Kursusportal',
      path: '/',

      children: [
        {
          children: [],
          label: 'Forside',
          path: '/home'
        },
        {
          label: 'Kurser',
          path: '/kurser',
          children: [
            {
              label: 'Almene Tværfaglige',
              path: '/kurser/' + this.Themeids[0],
              children: []
            },
            {
              label: 'Jobfunktion',
              path: '/kurser/' + this.Themeids[1],
              children: []
            },
            {
              label: 'Arbejdsområde',
              path: '/kurser/' + this.Themeids[2],
              children: []
            }
          ]
        },
        {
          children: [],
          label: 'Min Side',
          path: '/min-side'
        },
        {
          label: 'Rapporter',
          path: '/rapporter',
          isAdmin: true,
          children: [
            {
              label: 'Statistik',
              path: '/rapporter/statistik',
              children: []
            },
            {
              label: 'Fordeling',
              path: '/rapporter/fordeling',
              children: [],
            }
          ]
        },
        {
          icon: 'pencil',
          path: '/cms/nyheder',
          isAdmin: true,
          children: [
            {
              label: 'Rediger nyheder',
              path: '/cms/nyheder',
              children: []
            },
            {
              label: 'Rediger temasektioner',
              path: '/cms/temasektioner',
              children: [],
            },
            {
              label: 'Rediger sider',
              path: '/cms/sider',
              children: []
            }
          ]
        }
      ]
    }
  ];

  public getMenuItemsForUser(user: IUserColumns): IMenuItem[] {
    const isAdmin = user.isAdministrator;
    if (isAdmin) {
      return this.items;
    }

    const filter = (items: IMenuItem[]) => {
      const matches: IMenuItem[] = [];

      items.forEach((item: IMenuItem) => {
        if (item.isAdmin === true) {
          return;
        }

        matches.push({
          ...item,
          children: filter(item.children)
        });
      });

      return matches;
    };

    return filter(this.items);
  }

  public static get Instance(): RouteHelper {
    if (this.routeHelper == null) {
      this.routeHelper = new RouteHelper();
    }
    return this.routeHelper;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/RouteHelper.ts